import React from "react";
import { Modal } from "react-bootstrap";

import styles from "./modal.module.scss";

type PropsType = {
	show: boolean;
	onHide: () => void;
	showEditBtn: boolean;
	acquirerData: { [key: string]: any };
};

const AcquirerMatchContactModal = ({
	acquirerData = {},
	show,
	onHide,
}: PropsType) => {
	const LabeledValue = ({ label, value }) => (
		<div className="d-flex mt-3">
			<div className={styles.label}>{label}:</div>
			<div className={styles.value}>{value}</div>
		</div>
	);

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			className={styles.centeredLabelsModal}
		>
			<Modal.Header closeButton className="pb-0">
				<Modal.Title as="h6" className="text-center">
					Acquirer MATCH Contact
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="d-flex flex-column pt-0">
				<LabeledValue
					label="Acquirer Bank"
					value={acquirerData?.bank}
				/>
				<LabeledValue label="Region" value={acquirerData?.region} />
				<LabeledValue
					label="Contact First Name"
					value={acquirerData?.first_name}
				/>
				<LabeledValue
					label="Contact Last Name"
					value={acquirerData?.last_name}
				/>
				<LabeledValue
					label="Phone Number"
					value={acquirerData?.phone_number}
				/>
				<LabeledValue
					label="Fax Number"
					value={acquirerData?.fax_number}
				/>
				<LabeledValue
					label="Email Address"
					value={acquirerData?.email_address}
				/>
			</Modal.Body>
		</Modal>
	);
};

export default AcquirerMatchContactModal;
